import { nanoid } from 'nanoid';

import { type BuildQuizListItem } from './BuildQuizListSchema';

export const getBlankQuizItem = (): BuildQuizListItem => {
  return {
    id: nanoid(8),
    question: '',
    questionRichText: '',
    questionImageUrl: '',
    hint: undefined,
    type: 'multiple',
    multipleData: getBlankMultipleData(),
    subjectiveData: getBlankSubjectiveData(),
    oxData: getBlankOXData(),
    essayData: {},
    matchData: getBlankMatchData(),
  };
};

const getBlankMultipleData = () => {
  const firstChoiceKey = nanoid(8);
  return {
    choiceList: [
      {
        key: firstChoiceKey,
        text: '',
        richText: '',
        imageUrl: undefined,
        isAnswer: true,
      },
      {
        key: nanoid(8),
        text: '',
        richText: '',
        imageUrl: undefined,
        isAnswer: false,
      },
      {
        key: nanoid(8),
        text: '',
        richText: '',
        imageUrl: undefined,
        isAnswer: false,
      },
      {
        key: nanoid(8),
        text: '',
        richText: '',
        imageUrl: undefined,
        isAnswer: false,
      },
    ],
  };
};

const getBlankSubjectiveData = () => {
  const firstAnswerKey = nanoid(8);
  return {
    answerList: [{ key: firstAnswerKey, text: '' }],
  };
};

const getBlankOXData = () => {
  return {
    answer: 'o' as const,
  };
};

const getBlankMatchData = () => {
  const pairIds = Array.from({ length: 4 }, () => ({
    leftId: nanoid(8),
    rightId: nanoid(8),
  }));

  return {
    leftItems: pairIds.map(({ leftId }) => ({
      id: leftId,
      text: '',
      richText: '',
      imageUrl: undefined,
    })),
    rightItems: pairIds.map(({ rightId }) => ({
      id: rightId,
      text: '',
      richText: '',
      imageUrl: undefined,
    })),
    answerPairs: pairIds.map(({ leftId, rightId }) => ({ leftId, rightId })),
  };
};
